<template>
  <div id="mybill">
    <Breadcrumb></Breadcrumb>

    <div class="common-limit line-height-40">
      <div class="form-body">
        <el-form ref="form" :model="queryParams" label-width="80px">
          <el-row :gutter="24">
            <el-col :span="8">
              <el-form-item label="收支类型：" prop="fundType">
                <el-select
                  size="small"
                  clearable
                  v-model="queryParams.fundType"
                >
                  <template v-for="(value, key) in dictData['fund_type']">
                    <el-option
                      :key="value.value"
                      :label="value.label"
                      :value="value.value"
                    ></el-option>
                  </template>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="操作人员：" prop="operNo">
                <el-input size="small" v-model="queryParams.operNo" clearable />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="产生时间：" prop="time">
                <el-date-picker
                  size="small"
                  v-model="queryParams.time"
                  type="daterange"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                  :picker-options="pickerOptions"
                  start-placeholder="开始时间"
                  end-placeholder="结束时间"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="24">
            <el-col :span="24" class="btn-bar-right">
              <el-button type="primary" size="small" @click="loadData"
                >搜索</el-button
              >
              <el-button size="small" @click="resetForm">重置</el-button>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </div>
    <div class="form-body">
      <div style="overflow: hidden">
        <span style="float: left">
          <el-button type="primary" size="small" @click="handleExport"
            >导出</el-button
          >
        </span>
        <pagination
          v-show="total > 0"
          :total="total"
          :page.sync="queryParams.pageNum"
          :limit.sync="queryParams.pageSize"
          @pagination="loadData"
          :layout="'slot, total, sizes, prev, pager, next, jumper'"
        >
        </pagination>
      </div>
      <el-table border :data="tableData">
        <el-table-column align="center" label="流水编号" prop="fundId">
        </el-table-column>
        <el-table-column
          align="center"
          label="产生时间"
          prop="createTime"
          width="180"
        >
        </el-table-column>
        <el-table-column align="center" label="收支类型" prop="fundType">
          <template slot-scope="scope">
            <span>{{ dictMap["fund_type"][scope.row.fundType] }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="金额" prop="amount">
          <template slot-scope="scope">
            <span style="color: red" v-if="scope.row.fundType == '01'">
              + {{ scope.row.amount }}</span
            >
            <span style="color: green" v-if="scope.row.fundType == '02'">
              - {{ scope.row.amount }}</span
            >
          </template>
        </el-table-column>
        <el-table-column align="center" label="余额" prop="balance">
        </el-table-column>
        <el-table-column
          align="center"
          label="操作人员"
          prop="operNo"
        ></el-table-column>
        <el-table-column
          align="center"
          label="说明"
          prop="fundDesc"
          show-overflow-tooltip
        ></el-table-column>
      </el-table>
      <pagination
        class="bottom-sticky"
        v-show="total > 0"
        :total="total"
        :page.sync="queryParams.pageNum"
        :limit.sync="queryParams.pageSize"
        @pagination="loadData"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex"
import Breadcrumb from "@/components/common/Breadcrumb"
import { listFund, exportFundList } from "@/api/business/fundManage"
import { downLoadExcel } from "@/utils/zipdownload"
import qs from "qs"

export default {
  name: "Notice",
  components: {
    Breadcrumb,
  },
  data() {
    return {
      // 查询参数
      queryParams: {
        pageNum: 1,
        pageSize: 30,
        noticeStatus: undefined,
        operNo: undefined,
        noticeTitle: undefined,
        fundType: undefined,
        beginTime: undefined,
        endTime: undefined,
        time: [],
      },
      loading: false,
      total: 0,
      tableData: [],
    }
  },
  computed: {
    ...mapGetters(["dictData", "dictMap"]),
  },
  created() {
    let curDate = new Date()
    let preDate = new Date(curDate.getTime() - 24 * 60 * 60 * 1000 * 30)

    this.queryParams.time = [
      this.parseTime(preDate, "{y}-{m}-{d}"),
      this.parseTime(curDate, "{y}-{m}-{d}"),
    ]
    this.loadData()
  },
  methods: {
    loadData() {
      this.startLoading()
      if (this.queryParams.time) {
        this.queryParams.beginTime = this.queryParams.time[0]
        this.queryParams.endTime = this.queryParams.time[1]
      } else {
        this.queryParams.beginTime = undefined
        this.queryParams.endTime = undefined
      }
      let params = Object.assign({}, this.queryParams)
      delete params["time"]
      listFund(params)
        .then((response) => {
          this.tableData = response.rows
          this.total = response.total
          this.endLoading()
        })
        .catch(() => {
          this.endLoading()
        })
    },

    resetForm() {
      this.$refs["form"].resetFields()
    },

    /**导出 */
    handleExport() {
      if (this.queryParams.time) {
        this.queryParams.beginTime = this.queryParams.time[0]
        this.queryParams.endTime = this.queryParams.time[1]
      } else {
        this.queryParams.beginTime = undefined
        this.queryParams.endTime = undefined
      }
      let params = Object.assign({}, this.queryParams)
      delete params["time"]
      delete params["pageSize"]
      delete params["pageNum"]
      downLoadExcel(
        `/money/fund/export?${qs.stringify(this.queryParams)}&fileName=` +
          Math.random(),
        Math.random()
      )
    },
  },
}
</script>
<style lang="scss" scoped>
.btn-bar-right {
  text-align: right;
}
</style>
